export enum BusinessStructureType {
    Undefined = '',
    Individual = 'Individual',
    Corporation = 'Corporation',
    Partnership = 'Partnership',
    Trust = 'Trust',
    Other = 'Other'
}

export enum JurisdictionType {
    Federal = 'Federal',
    Provincial = 'Provincial',
    Foreign = 'Foreign',
}

export enum AddressType {
    Physical = 'physicalAddress',
    Mailing = 'mailingAddress',
    Records = 'recordsAddress',
    Generic = 'genericAddress',
    Plant = 'plantAddress',
    AccountsPayable = 'accountsPayableAddress'
}

export enum PhoneNumberMask {
    WithAreaCode = '000-000-0099',
    WithoutAreaCode = '000-0000',
    WorldWide = '0*',
}

export enum OtherAddressTypes {
    PlantAddress = 'PLANT A',
    AccountsPayableDepartment = 'ACCPYBLE A',
    BooksAndRecords = 'BKSRCRDS A',
}

export enum EnrolmentStatus {
    DRAFT = 'DRAFT',
    CASE_PENDING_FILE_UPLOAD = 'CASE_PENDING_FILE_UPLOAD',
    SUBMITTED_PROCESSING = 'SUBMITTED_PROCESSING',
    ERROR = 'ERROR',
    INFORMATION_REQUIRED = 'INFORMATION_REQUIRED',
    SECURITY_DEPOSIT_REQUIRED = 'SECURITY_DEPOSIT_REQUIRED',
    COMPLETE = 'COMPLETE',
}

export enum RegistrationStatus {
    DRAFT = 'DRAFT',
    SUBMITTED_PROCESSING = 'SUBMITTED_PROCESSING',
    ERROR = 'ERROR',
    COMPLETE = 'COMPLETE',
}

/**
 * These are returned from BE after submitting the validate-business-information form,
 * and these are keys in localization files (in errors sections) to display the localized error message
 */
export enum ValidateBusinessErrorCode {
    CraMismatch = 'carm.business.registration.no.match.found.by.cra',
    RegistrationConflict = 'carm.business.registration.match.found.by.cra.but.ca.co.found.error.message',
    AutomatedBusinessRegistrationFailed_Scenario2 = 'carm.business.registration.info.cra.no.response.found.unable.register',
    RegistrationAlreadyStarted = 'carm.business.registration.already.started.error.message',
    RegistrationBAMFoundError = 'carm.business.registration.BAM.found.error.message',
    RegistrationBAMFoundInHybrisError = 'carm.business.registration.BAM.found.in.hybris.error.message',
    RegistrationValidationError = 'carm.business.registration.validate.error.message',
    RegistrationValidationBusinessNumberError = 'carm.business.registration.validate.businessNumber.error.message',
    RegistrationValidationProgramIdError = 'carm.business.registration.validate.programId.error.message',
    RegistrationValidationNotFoundProgramidError = 'carm.program.with.id.not.found.error.message',
    RegistrationBusinessFoundInHybrisError = 'carm.business.registration.business.found.in.hybris.error.message',
    RegistrationLegalEntityValidationFailureError = 'carm.business.registration.legal.entity.validation.failure.error.message',
    RegistrationBusinessFoundButDataNotMatchError = 'carm.business.registration.no.match.found.by.cra'
}

export enum RegistrationProgramType {
    Carrier = 'Carrier',
    SufferanceWarehouse = 'Sufferance Warehouse',
    BondedWarehouse = 'Bonded Warehouse',
    DutyFreeShop = 'Duty-free Shop',
}

export const allowedProvincesToBeRegistered = ['NL', 'NT', 'NU', 'QC', 'YT'];

export enum OperationMetadataTypes {
  Corporation = 'corporation',
  Individual = 'individual',
  Partnership = 'partnership',
}

export enum TransactionQuestion {
  ReferenceDocumentNumber = 'ReferenceDocumentNumber',
  PaymentAmt = 'PaymentAmt',
  SOATotal = 'SOATotal'
}
